export const API = "https://my-ecommerce-test.herokuapp.com/api/";
